import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'maskEmail'
})
export class MaskEmailPipe implements PipeTransform {

  transform(email: string): string {
    if (!email) {
      return '';
    }

    const atIndex = email.indexOf('@');
    if (atIndex === -1) {
      return email;
    }

    const localPart = email.substring(0, atIndex);
    const domainPart = email.substring(atIndex + 1);

    const firstTwoLocal = localPart.substring(0, 2);
    const remainingLocalLength = localPart.length - 2;
    const asterisksLocal = '*'.repeat(Math.max(0, remainingLocalLength));

    const firstTwoDomain = domainPart.substring(0, 2);
    const remainingDomain = domainPart.substring(2);
    const asterisksDomainLength = remainingDomain.indexOf('.'); // Maschera fino al primo punto nel dominio
    const maskedDomainPart =
      asterisksDomainLength > 0
        ? firstTwoDomain + '*'.repeat(asterisksDomainLength) + remainingDomain.substring(asterisksDomainLength)
        : firstTwoDomain + '*'.repeat(Math.max(0, domainPart.length - 2));


    return firstTwoLocal + asterisksLocal + '@' + maskedDomainPart;
  }

}
